import React, { useState } from "react";
import { Tabs } from "components/navigation";
import { AuditingTable } from "components/auditing";
import { LicenceCheckingService } from "services";

export function GreyFleetHistory() {
    const noDataMessage =
        "No changes have been made for the selected date period";
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState(null);
    const [tableRecordCount, setTableRecordCount] = useState(0);
    const [tabTitle, setTabTitle] = useState("Settings");
    const [tabSettings, setTabSettings] = useState([
        { key: "SETTINGS", title: "Settings", selected: true },
        { key: "POLICIES", title: "Policies", selected: false },
    ]);

    function onTabClick(tabIndex) {
        setTabSettings((prev) => {
            setTabTitle(prev[tabIndex].title);
            return prev.map(function (c, index) {
                return {
                    ...c,
                    selected: index === tabIndex,
                };
            });
        });
    }

    function onTableChange(pageSize, pageNumber, startDate, endDate) {
        setIsLoading(true);
        LicenceCheckingService.getGreyFleetSettingsHistory(tabTitle, pageSize, pageNumber, startDate, endDate).then(r => {
            setTableData(r.data);
            setTableRecordCount(r.totalCount);
            setIsLoading(false);
        });
    }

    return (
        <div className="row">
            <div className="row">
                <h2>History</h2>
                <div className="spacer-bottom">
                    <Tabs
                        tabs={tabSettings}
                        onClick={onTabClick}
                        disabled={isLoading}
                    />
                </div>
            </div>
            <AuditingTable
                hideHeader
                key={tabTitle}
                data={tableData}
                totalCount={tableRecordCount}
                onChange={onTableChange}
                noDataMessage={noDataMessage}
                loading={isLoading}
            ></AuditingTable>
        </div>
    );
}
